function Header() {
    return (
        <header className="header">
            <div>
                <a href="/">Mong<span>Converter</span></a>
                <ul>
                    <li>About</li>
                    <li>How It Works</li>
                    <li>FAQ</li>
                </ul>
            </div>
        </header>
    );
}


export default Header;